import { Controller } from 'stimulus'

// The Sample Storage screen's filters: the search submits the GET form a
// moment after the last keystroke, the Job location picker right away.
export default class extends Controller {
  static targets = ['input']

  // Each search reloads the page; keep typing where it left off.
  connect() {
    if (!this.inputTarget.value) return
    const { length } = this.inputTarget.value
    this.inputTarget.focus()
    this.inputTarget.setSelectionRange(length, length)
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  queue() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.submit(), 400)
  }

  // Also the Job location picker's change action.
  submit() {
    clearTimeout(this.timer)
    if (this.element.requestSubmit) {
      this.element.requestSubmit()
    } else {
      this.element.submit()
    }
  }
}
